<template>
  <div>
    <vs-breadcrumb class="mb-6" :items="
   [
     {
       title: '权限',
       url: '/auth/role'
     },
     {
       title: '角色管理',
       active: true
     }
   ]"></vs-breadcrumb>

    <div>
      <vs-table ref="table" pagination :max-items="itemsPerPage" :data="list" :noDataText="noDataText" :stripe="true">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="flex flex-wrap-reverse items-center">
            <!-- ADD NEW -->
            <div
              class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
              @click="gotoNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">创建新角色</span>
            </div>
          </div>
        </div>

        <template slot="thead">
          <vs-th>操作<br />
            创建/更新时间</vs-th>
          <vs-th>角色名称</vs-th>
          <vs-th>状态</vs-th>

        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :key="index" v-for="(tr, index) in data">
              <vs-td>
                <div>
                  <a href="javascript:void(0)" @click="editData(tr)" class="mr-1">编辑</a>
                  <!-- <a href="javascript:void(0)" @click="delData(tr)">删除</a> -->
                </div>
                <div class="text-muted">
                  创建时间:
                  <br /> {{tr.created_at}}
                </div>
                <div class="text-muted">
                  更新时间:
                  <br /> {{tr.updated_at}}
                </div>
              </vs-td>
              <!-- <vs-td>{{tr.id}}</vs-td> -->
              <vs-td><span class="text-bold">{{tr.name}}</span></vs-td>
              <vs-td>
                <ul class="con-s">
                  <li>
                    <div class="mb-1">{{Number(tr.status) === 1?'可用':'已禁用'}}</div>
                    <vs-switch v-model="tr.status" @input="changeSwitch(tr)" />
                  </li>
                </ul>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        list: [],
        itemsPerPage: 20,
        noDataText: ''
      }
    },

    methods: {

      gotoNewData: function () {

      },


      delData: function (item) {

      },

      editData: function (item) {

        this.item = item
        this.editPopUpActive = true
      },

      changeSwitch: function (e) {
        //当前修改的item
        console.log('e:', e)
      },
    }
  }

</script>
<style scoped>

</style>
